import type React from 'react';
import classNames from '../../../../utils/classNames';
import { fieldFrameClasses } from '../../../form/Input';
import type { OverviewTab } from '../types';

interface Props {
    value: OverviewTab;
    onChange: (value: OverviewTab) => void;
    options: Array<{ value: OverviewTab; label: string }>;
    ariaLabel: string;
}

export function OverviewTabToggle({
    value,
    onChange,
    options,
    ariaLabel,
}: Props): React.ReactElement {
    return (
        <div
            className={classNames(
                'inline-flex w-full min-w-0 items-stretch p-1 md:flex-1',
                fieldFrameClasses
            )}
            role="tablist"
            aria-label={ariaLabel}
        >
            {options.map((option) => {
                const isSelected = option.value === value;

                return (
                    <button
                        key={option.value}
                        id={`overview-tab-${option.value}`}
                        type="button"
                        role="tab"
                        aria-selected={isSelected}
                        className={classNames(
                            'flex-1 whitespace-nowrap rounded border-l-4 px-4 py-1 text-left text-sm leading-normal transition-colors',
                            isSelected
                                ? 'border-primary bg-white text-gray-900'
                                : 'border-transparent text-gray-400 hover:text-gray-600'
                        )}
                        onClick={() => onChange(option.value)}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}
